export default __webpack_public_path__ + "static/media/signature.bf1330c4.png";